import { Box } from "@material-ui/core";
import { useContext } from "react";
import FormBase from "../../../../forms/FormBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";
import { ReRegistrationProfessionalPrivilegeFormItem } from "../../../../forms/recadastramento/ReRegistrationProfessionalPrivilegeForm";
import ReRegistrationProfessionalPrivilegeComponent from "../../../components/tempo/Recadastramento/ReRegistrationProfessionalPrivilegeComponent";
import TmpShapeCustom from "../../../../components/tempo/TmpShapeCustom/TmpShapeCustom";


export default function MedicalPrivilegeStep() {

    const { state, dispatch } = useContext(RecadastramentoContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudPrivilegesIParticipaInteAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', formItem?: ReRegistrationProfessionalPrivilegeFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_PROFESSIONAL_PRIVILEGE",
            payload: { subType: subTypeParam, item: formItem },
        });
    };

    return (
        <div>
            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2}>
                    Escopo de Atuação
                </TmpTitleFormCustom>

                <Box mt={2} mb={4}>

                    <ReRegistrationProfessionalPrivilegeComponent
                        ReRegistrationProfessionalPrivilegeForm={state.ReRegistrationProfessionalPrivilegeForm}
                        onCancelItem={() => { onCrudPrivilegesIParticipaInteAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudPrivilegesIParticipaInteAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationProfessionalPrivilegeFormItem) => { onCrudPrivilegesIParticipaInteAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationProfessionalPrivilegeFormItem) => { onCrudPrivilegesIParticipaInteAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>


        </div >
    )
}